import { CreditCardMarkerOutlineIcon } from './CreditCardMarkerOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B026E6BC-FFD6-44FA-96AC-6F4A902FD596
 * name credit-card-marker-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-marker-outline.svg
 * tags
 * - Banking 
 * - Navigation 
 */
export const PaymentOnDeliveryOutlineIcon = CreditCardMarkerOutlineIcon;
export default PaymentOnDeliveryOutlineIcon